import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import AutoFillList from './AutoFillList';

const mapStateToProps = state => {
    return {
        campaignState: state.campaignReducer,
    }
};

// const mapDispatchToProps = (dispatch) => {
//     return {
//         getAgentDetail: (id) => dispatch(agentActions.getAgentDetail(id)),
//     }
// };

export default withTranslation()(connect(mapStateToProps, null)(AutoFillList));
